import script from "./LandingIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingIndex.vue?vue&type=script&setup=true&lang=ts"

import "./LandingIndex.vue?vue&type=style&index=0&id=5682d387&lang=scss"
import "./LandingIndex.vue?vue&type=style&index=1&id=5682d387&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5682d387"]])

export default __exports__